module.exports = __webpack_public_path__ + "img/icon_transfer_sesama.4e3cd227.png";